
// export const firebaseConfig  = {
//     apiKey: "AIzaSyCsTqEOpw-jL-VQCZf9_tWE374K-FPy6n4",
//     authDomain: "ome-virtual-dev.firebaseapp.com",
//     databaseURL: "https://ome-virtual-dev.firebaseio.com",
//     projectId: "ome-virtual-dev",
//     storageBucket: "ome-virtual-dev.appspot.com",
//     messagingSenderId: "1071201651092",
//     appId: "1:1071201651092:web:7a74e2c46bca55bc9be781"
// };

export const firebaseConfig  = {
    apiKey: "AIzaSyBw7wFoLGca_eacP8bewO18MiTdIbkWlFg",
    authDomain: "ome-virtual.firebaseapp.com",
    databaseURL: "https://ome-virtual.firebaseio.com",
    projectId: "ome-virtual",
    storageBucket: "ome-virtual.appspot.com",
    messagingSenderId: "1062866155294",
    appId: "1:1062866155294:web:2a44886a9e135628227b0f"
};
